import { BookmarkIcon, CircleInfoIcon, ImageIcon, ItemsIcon, StackIcon, VariantIcon } from "@xola/icons";
import React, { useMemo } from "react";
import { Merchandise } from "types";
import { MerchandiseDescriptiveContent } from "@/components/Product/Merchandise/MerchandiseDescriptiveContent";
import { MerchandiseFulfillment } from "@/components/Product/Merchandise/MerchandiseFulfillment";
import { MerchandiseInventory } from "@/components/Product/Merchandise/MerchandiseInventory";
import { MerchandiseItems } from "@/components/Product/Merchandise/MerchandiseItems";
import { MerchandisePhotoList } from "@/components/Product/Merchandise/MerchandisePhotoList";
import { MerchandisePricing } from "@/components/Product/Merchandise/MerchandisePricing";

export const useMerchandiseTabs = (merchandise?: Merchandise) => {
    const tabs = useMemo(
        () => [
            {
                id: "descriptive",
                label: "Descriptive Content",
                icon: <CircleInfoIcon size="large" />,
                description: "Important details that will be presented to your customer throughout the booking process",
                content: <MerchandiseDescriptiveContent merchandise={merchandise} />,
            },
            {
                id: "photos",
                label: "Photos",
                icon: <ImageIcon size="large" />,
                condition: !!merchandise,
                description:
                    "Set your primary photo which will be set as the image in the back office and in online checkout",
                content: merchandise && <MerchandisePhotoList merchandise={merchandise} />,
            },
            {
                id: "pricing",
                label: "Payments, Channels & Fees",
                icon: <StackIcon size="large" />,
                condition: !!merchandise,
                description:
                    "Manage allowed payment methods, taxes & fees and the channels this product can be sold through.",
                content: merchandise && <MerchandisePricing merchandise={merchandise} />,
            },
            {
                id: "inventory",
                label: "Variants & Inventory",
                icon: <VariantIcon size="large" />,
                condition: !!merchandise,
                description: "Manage multiple versions of this product in groups like colors or sizes.",
                content: merchandise && <MerchandiseInventory merchandise={merchandise} />,
            },
            {
                id: "items",
                label: "Items",
                icon: <ItemsIcon size="large" />,
                condition: !!merchandise,
                description: "Configure pricing and display options for each version of this product.",
                content: merchandise && <MerchandiseItems merchandiseId={merchandise.id} />,
            },
            {
                id: "fulfillment",
                label: "Fulfillment",
                icon: <BookmarkIcon size="large" />,
                condition: !!merchandise,
                description: "Manage fulfillment settings",
                content: merchandise && <MerchandiseFulfillment merchandise={merchandise} />,
            },
        ],
        [merchandise],
    );

    return tabs;
};
